import { useInitSentry } from './init-sentry'
import { useSetSentryScope } from './set-sentry-scope'

export function useSentry() {
  useInitSentry()
  useSetSentryScope()
}
